export default __webpack_public_path__ + "static/media/app-store.9df9a5a6.png";